var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMxIconLinkOut(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 9,
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.6363 6.72728H7.13631C4.68177 6.72728 3.86359 9.01164 3.86359 10.8182C3.86359 12.6256 5.09086 14.0909 5.09086 14.0909C5.09086 14.0909 5.09086 13.1754 5.09086 12.0455C5.09086 11.2273 5.49995 10.8182 7.13631 10.8182H11.6363V13.2727L15.7272 8.77274L11.6363 4.27274V6.72728Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMxIconLinkOut);
export default __webpack_public_path__ + "static/media/mxIconLinkOut.b34d26a3254c60973d4d55bdde6047b1.svg";
export { ForwardRef as ReactComponent };